<template>
  <ul id="mainMenu" class="menu menu--overflow-y-hidden" @mouseleave="hideAllSubmenus">
      <li class="menu__item"
          @mouseover="saleBanners.length ? menuMouseOver($event) : ''"
          @mouseleave="hideAllSubmenus"
          @touchstart="saleBanners.length ? menuMouseOver($event) : ''">
          <div class="menu__bookmark menu__bookmark--sale" :class="{'menu__bookmark--sale--hover': !saleBanners.length}">
              <a class="menu__link menu__link--wrapper"
                  :class="{'menu__link--arrow': saleBanners.length}"
                  :href="dictionary.siteHeader.sale.url">
          <span class="menu__link--sale">
            {{ dictionary.siteHeader.sale.title }} <span class="menu--arrow"></span>
          </span>
              </a>
          </div>
          <div class="menu__submenu menu__submenu--sale">
              <div v-if="saleBanners.length" class="menu__submenu--sale-box">
                  <div class="menu__submenu--sale-title">
                      {{ dictionary.siteHeader.sale.title }}
                  </div>
                  <BannersSale :sale-banners="saleBanners" @click-button="hideAllSubmenus" />
                  <div class="menu__submenu--sale-more">
                      <a :href="dictionary.siteHeader.sale.url" class="btn btn-primary py-1 rounded-25 mb-4" @click="hideAllSubmenus">
                          {{ dictionary.siteHeader.sale.more }}
                      </a>
                  </div>
              </div>

          </div>
      </li>

<!--     <li @mouseover="hideAllSubmenus" class="menu__item">-->
<!--        <div class="menu__bookmark">-->
<!--            <a class="menu__link" :href="dictionary.siteHeader.christmas.url">-->
<!--                <span class="menu__link&#45;&#45;christmas">-->
<!--                  <img src="/nuxt-assets/icons/christmas.svg" width="30" height="30" />-->
<!--                  {{ dictionary.siteHeader.christmas.title }}-->
<!--                </span>-->
<!--            </a>-->
<!--        </div>-->
<!--    </li>-->

<!--    <li @mouseover="hideAllSubmenus" class="menu__item" style="vertical-align: bottom;">
      <div class="menu__bookmark">
        <a class="menu__link" :href="dictionary.siteHeader.blackFriday.url">
          <span class="menu__link--blackFriday">
            <img src="/nuxt-assets/icons/blackFriday.png" width="15" height="15" />
            {{ dictionary.siteHeader.blackFriday.title }}
          </span>
        </a>
      </div>
    </li>-->
    <li
        v-for="(menuItem, iterate) in Object.values(items)"
        :key="iterate"
        class="menu__item"
        @mouseover="menuItem.items && menuItem.items.length > 0 ? menuMouseOver($event, menuItem) : hideAllSubmenus()"
    >
      <template v-if="iterate < maxMenuItems">
        <div class="menu__bookmark" :class="{
            'menu__bookmark--highlight' : xmasCategoryId === menuItem.id,
            'menu__bookmark--highlight' : menuHighlightCategory === menuItem.id
            }" @click="hideAllSubmenus">
          <!-- Link -->
          <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" :class="{
                                'menu__link' : menuItem.items.length > 0,
                                'menu__href' : menuItem.items.length === 0,
                                'menu__link--wrapper' : xmasCategoryId === menuItem.id,
                                'menu__link--wrapper' : menuHighlightCategory === menuItem.id,
                            }"
                     :href="menuItem.url">
              <span :class="{
                  'menu__link--highlight menu__link--xmas' : xmasCategoryId === menuItem.id,
                  'menu__link--highlight menu__link--sale' : menuHighlightCategory === menuItem.id,
              }">{{ menuItem.name }}</span>
          </a>
          <a v-else
                     :class="{
                                'menu__link' : menuItem.items.length > 0,
                                'menu__href' : menuItem.items.length === 0,
                                'menu__link--wrapper' : xmasCategoryId === menuItem.id,
                                'menu__link--wrapper' : menuHighlightCategory === menuItem.id,
                            }"
                     :href="menuItem.url">
              <span :class="{
                  'menu__link--highlight menu__link--xmas' : xmasCategoryId === menuItem.id,
                  'menu__link--highlight menu__link--sale' : menuHighlightCategory === menuItem.id,
              }">{{ menuItem.name }}</span>
          </a>
          <!-- end Link -->
        </div>
        <div v-if="menuItem.items.length > 0" class="menu__submenu" @scroll="showScrollDownSubmenu" @mouseleave="hideAllSubmenus">
          <ul class="menu-second">
            <li
                v-for="(menuItem1, idx) in menuItem.items"
                :key="idx"
                class="menu-second__item"
                @mouseover="menuMouseOverSubmenu($event, idx)"
                @click="setItemActive($event, idx)"
            >
              <!-- Link -->
              <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" class="menu-second__link"
                        :class="idx === 0 ? 'with-arrow with-arrow--active' : ''"
                        :href="menuItem1.url">
                <span class="menu-second__icon">
                    <img v-if="menuItem1.cdnImage" :src="menuItem1.cdnImage" :alt="menuItem1.imageAlt || menuItem1.name" width="22" height="22" loading="lazy" />
                </span>
                {{ menuItem1.name }}
              </a>
              <a v-else class="menu-second__link" :class="idx === 0 ? 'with-arrow with-arrow--active' : ''"
                 :href="menuItem1.url">
                <span class="menu-second__icon">
                    <img v-if="menuItem1.cdnImage" :src="menuItem1.cdnImage" :alt="menuItem1.imageAlt || menuItem1.name" width="22" height="22" loading="lazy" />
                </span>
                {{ menuItem1.name }}
              </a>
              <!-- end Link -->
            </li>
          </ul>

          <div class="menu-second__submenu" @mouseover="submenuDelay">
            <ul class="menu-second__subsubmenu" v-if="menuItem.items && menuItem.items[indexL3]">

              <li class="showAll" @click="hideAllSubmenus">
                <!-- Link -->
                <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" class="goBack menu-second__link text-primary"
                    :href="menuItem.items[indexL3].url">{{ dictionary.siteHeader.seeAllCategory }} {{ menuItem.items[indexL3].name }}
                </a>
                <a v-else class="goBack menu-second__link text-primary"
                   :href="menuItem.items[indexL3].url">{{ dictionary.siteHeader.seeAllCategory }} {{ menuItem.items[indexL3].name }}
                </a>
                <!-- end Link -->
              </li>
              <template v-if="menuItem.items[indexL3]">
                <li v-for="(menuItem2, menuItem2Index) in menuItem.items[indexL3].items" :key="menuItem2Index"  @click="hideAllSubmenus" class="menu-second__item">
                  <!-- Link -->
                  <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" class="menu-second__link" :href="menuItem2.url">{{ menuItem2.name }} </a>
                  <a v-else class="menu-second__link" :href="menuItem2.url">{{ menuItem2.name }} </a>
                  <!-- end Link -->
                </li>
              </template>
            </ul>
          </div>

          <div class="right-section">
            <BrandsPoster :dictionary="dictionary" @hideMenu="hideAllSubmenus" :menu-banners="menuBanners.filter(item => item.objectId === menuItem.id)" :is-pwa="isPwa" @redirectToUrl="redirectToUrl" />
            <ProductPoster
                v-if="menuItemProducts[menuItem.objectId]"
                :dictionary="dictionary"
                :product="menuItemProducts[menuItem.objectId].product"
                :title="menuItemProducts[menuItem.objectId].title"
                :is-pwa="isPwa"
                :basket-amount="productAmounts[menuItemProducts[menuItem.objectId].product.id] || 0"
                @addProductToBasket="addProductToBasket"
                @hideMenu="hideAllSubmenus"
                @redirectToUrl="redirectToUrl"
            >
                <template v-slot:product="{ product }">
                    <slot name="product" v-bind="{ product }"></slot>
                </template>
            </ProductPoster>
          </div>


        </div>
      </template>
    </li>
    <li
        v-if="maxMenuItems < Object.keys(items).length"
        class="menu__item menu__item--simple"
        @mouseover="menuMouseOver($event)"
        @mouseleave="hideAllSubmenus"
    >
      <div class="menu__bookmark">
        <a href="#" class="menu__link menu__link--arrow">
          {{ dictionary.siteHeader.moreCategories }}<span class="menu--arrow menu--arrow--all"></span>
        </a>
      </div>
      <div class="menu__submenu menu__submenu--simple">
        <ul class="menu-second">
          <template
              v-for="(menuItem, idx) in items"
          >
            <li :key="idx" v-if="idx > maxMenuItems - 1" class="menu-second__item" @click="hideAllSubmenus">
              <!-- Link -->
              <a @click.prevent="$emit('redirectToUrl', $event)" v-if="isPwa" :href="menuItem.url" class="menu-second__link">
                {{ menuItem.name }}
              </a>
              <a v-else :href="menuItem.url" class="menu-second__link">
                {{ menuItem.name }}
              </a>
              <!-- ende Link -->
            </li>
          </template>
        </ul>
      </div>
    </li>

    <li v-if="dictionary.siteHeader.articles" @mouseover="hideAllSubmenus" class="menu__item" style="vertical-align: bottom;">
      <div class="menu__bookmark">
        <a class="menu__link" :href="dictionary.siteHeader.articles.url">
          <span class="menu__link--articles">
            {{ dictionary.siteHeader.articles.title }}
          </span>
        </a>
      </div>
    </li>

    <li
        v-if="dictionary.siteHeader.brands"
        @mouseover="menuBrandBanners.length ? menuMouseOver($event) : ''"
        @mouseleave="hideAllSubmenus"
        @touchstart="menuBrandBanners.length ? menuMouseOver($event) : ''"
        class="menu__item"
        style="vertical-align: bottom;"
    >
      <div class="menu__bookmark">
        <a class="menu__link" :href="dictionary.siteHeader.brands.url">
          <span class="menu__link--articles">
            {{ dictionary.siteHeader.brands.title }}
          </span>
        </a>
      </div>
      <div class="menu__submenu menu__submenu--brands">
        <div style="width: 100%;">
          <BrandsPoster :cols="3" :dictionary="dictionary" @hideMenu="hideAllSubmenus" :menu-banners="menuBrandBanners" :is-pwa="isPwa" @redirectToUrl="redirectToUrl" />
          <div class="text-center">
            <a :href="dictionary.siteHeader.brands.url" class="menu__brand-button">{{ dictionary.siteHeader.brands.showAllBrands }}</a>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import BrandsPoster from '../elements/BrandsPoster'
import ProductPoster from '../elements/ProductPoster'
import BannersSale from "./BannersSale.vue";
const SERVICE_CATEGORY_ID = 6344

export default {
  components: {
    BrandsPoster,
    ProductPoster,
    BannersSale,
  },
  data() {
    return {
      clinicCategoriesId: SERVICE_CATEGORY_ID,
      timeDelay: 300,
      maxMenuItems: 20,
      el: 'a.close',
      indexL3: 0,
      menuHide: null,
    }
  },
  props: {
    productAmounts: {
      type: Object,
      required: false,
      default: () => {},
    },
    isPwa: {
      type: Boolean,
      required: true,
    },
    items: {
      default: false,
      required: true,
    },
    pinnedCategories: {
      default: false,
    },
    menuBanners: {
      default: false,
    },
    menuBrandBanners: {
      type: Array,
    },
    menuItemProducts: {
      default: false,
    },
    xmasCategoryId: {
      type: Number,
      required: false,
    },
    menuHighlightCategory: {
      type: Number,
      required: false,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    saleBanners: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', () => this.resize())
  },
  methods: {
    addProductToBasket(data) {
      this.$emit('addProductToBasket', data)
    },

    redirectToUrl(data) {
      this.$emit('redirectToUrl', data)
    },

    isSubmenuShown(menuItem, submenuItem) {
      return submenuItem.items.length > 0 && menuItem.id !== SERVICE_CATEGORY_ID
    },
    resize(){
      this.maxMenuItems = 20
      this.$nextTick(function () {
          const mainMenu = document.getElementById('mainMenu')
          if (!mainMenu) {
            return
          }
          let clientWidth = mainMenu.clientWidth;
          let menuWidth = 0;
          let countItems = 0;
          let isMenuOverflowed = false

          const items = [...document.getElementById('mainMenu').querySelectorAll('.menu__item')]
          items.forEach(function (item) {
              menuWidth += item.offsetWidth

              if (menuWidth < clientWidth) {
                  countItems += 1
              } else {
                  isMenuOverflowed = true
              }
          })
          this.maxMenuItems = countItems
          if (isMenuOverflowed) {
              this.maxMenuItems -= 4
          }

          mainMenu.classList.remove('menu--overflow-y-hidden')
      })
    },
    hideAllSubmenus() {
      const menu = document.getElementsByClassName('menu')[0]
      const nav = document.getElementsByClassName('site-header')[0]

      clearTimeout(this.menuShow, this.menuHide)
      this.menuHide = setTimeout(function () {
        menu.classList.remove('menu--opened')
        nav.classList.remove('site-header--open')

        document.querySelectorAll('.menu__submenu').forEach(function(event) {
          event.classList.remove('menu__submenu--open')
        })

        document.querySelectorAll('.menu__item').forEach(function(event) {
          event.classList.remove('menu__item--active')
        })
      }, this.timeDelay)
    },
    menuMouseOver(event) {
      event.preventDefault()
      const menuItem = event.currentTarget
      const submenuLink = menuItem.querySelector('.menu__link')
      const nav = document.getElementsByClassName('site-header')[0]
      const menu = document.getElementsByClassName('menu')[0]

      clearTimeout(this.menuShow, this.menuHide)
      this.menuShow = setTimeout(() => {
        // eslint-disable-next-line
        // useNuxtApp().$bus.$emit('menuMouseOver')
        document.querySelectorAll('.menu__item').forEach(function (event) {
          event.classList.remove('menu__item--active')
        })
        menu.classList.add('menu--opened')
        menuItem.classList.add('menu__item--active')

        if(submenuLink) {
          submenuLink.classList.add('menu__link--active')
        }

        nav.classList.add('site-header--open')
      }, this.timeDelay)
    },
    submenuDelay(){
      clearTimeout(this.menuShowSubmenu, this.menuHide)
    },
    setItemActive(event, idx){
        this.hideAllSubmenus()
        if (idx >= 0) {
            const menuItem = event.currentTarget
            const submenuParent = menuItem.parentElement
            setTimeout(() => {
                submenuParent.querySelector('.with-arrow').classList.add('with-arrow--active')
            }, 400)
        }
    },
    menuMouseOverSubmenu(event, idx) {
      event.preventDefault()
      const menuItem = event.currentTarget
      const submenuLink = menuItem.querySelector('.menu-second__link')
      const submenuParent = menuItem.parentElement
      clearTimeout(this.menuShowSubmenu, this.menuHide)
      this.menuShowSubmenu = setTimeout(() => {
        if(idx >= 0) {
          this.indexL3 = idx
            if (submenuParent.querySelector('.with-arrow--active')) {
                submenuParent.querySelector('.with-arrow--active').classList.remove('with-arrow--active')
            }
            submenuLink.classList.add('with-arrow--active')
        }
      }, this.timeDelay)
    },

    scrollDownMenu(event) {
      const arrow = event.currentTarget
      const submenuParent = arrow.parentElement
      submenuParent.scrollBy(0, 500);
      arrow.style.display = 'none'
    },
    showScrollDownSubmenu(e){
      const submenu = e.target.getElementsByClassName('menu--scroll')[0]
      if( submenu ) {
        if (e.target.scrollTop < 10) {
          submenu.style.display = "flex";
        } else {
          submenu.style.display = "none";
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.right-section {
  position: absolute;
  top: 0;
  right: 20px;
  width: 40%;

  @media (max-width: 980px) {
    width: 30%;
  }
}
.menu {
  position: relative;
  justify-content: stretch;
  width: 100%;
  padding-left: 0;
  margin-bottom: 0;
  font-size: 14px;
  list-style: none;
  margin-top: 10px;

  &--overflow-y-hidden {
    overflow-y: hidden;
    max-height: 42px;
  }

  a {
    text-decoration: none;
  }

  &::after {
    position: absolute;
    top: 100%;
    right: 0;
    //left: -100%;
    z-index: 0;
    width: 300%;
    height: 100vh;
    visibility: hidden;
    content: '';
    background-color: #000;
    opacity: 0;
    transition: visibility 0s, opacity 150ms ease-in-out;
  }

  &-second {
    position: relative;
    width: 30%;
    height: auto;
    padding: 0;
    background: #f6f6f6;
    transition: opacity 0.3s ease;

    &__link {
      position: relative;
      display: block;
      width: 100%;
      padding: 5px 30px;
      overflow: hidden;
      line-height: 36px;
      color: #333;
      text-overflow: ellipsis;
      white-space: nowrap;
      align-items: center;

      &.with-arrow {
        &:hover,
        &--active {
          background: #fff;

          &::after {
            position: absolute;
            top: calc(50% - 9px);
            right: 15px;
            display: block;
            width: 15px;
            height: 15px;
            content: '';
            border: solid black;
            border-width: 0 1px 1px 0;
            padding: 5px;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            //background: url('/static/nuxt-assets/images/icons/arrow-menu.svg') no-repeat center center;
          }

          .menu-second__icon {
            border: 1px solid #C2A4D1;
            background: #F6F6F6;
          }
        }
      }

      &:hover,
      &--active {
        color: #e6007e;
      }
    }

    &__item {
      width: 100%;
      list-style-type: none;
    }

    &__icon {
      width: 34px;
      height: 34px;
      border-radius: 100px;
      border: 1px solid #fff;
      margin-right: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.125s;
      float: left;

      img {
        max-height: 22px;
        max-width: 22px;
        width: auto;
      }
    }

    &__submenu {
      width: 30%;

      ul {
        padding: 0;
      }

      &--active {
        display: block;
        visibility: visible;
        left: 100%;
        opacity: 1;

        @media (max-width: 980px) {
          display: block;
          visibility: visible;
          opacity: 1;
          left: 100%;
          height: 101%;
          overflow: hidden;
          overflow-y: auto;
        }
      }

      .menu-second__link {
        line-height: 25px;
        padding: 10px 30px;
      }
    }

    &__subsubmenu {
      @media (max-width: 980px) {
        padding: 0;
      }
    }
  }

  &--arrow {
    position: absolute;
    top: 44%;
    right: 18px;
    left: auto;
    height: 0;
    width: 0;
    content: '';
    border-top: 7px solid black;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;

    &--all {
      top: 44%;
      right: 9px;
    }
  }

  .brands {
    padding: 15px;
    transition: opacity 0.1s ease;
  }

  &__href {
    position: relative;
    display: flex;
    flex-grow: 1;
    font-size: 14px;
    line-height: 42px;
    color: #333;
    align-self: center;
    text-align: center;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-weight: 500;

    &:hover {
      color: #e6007e;
    }
    &.menu__link--wrapper {
        padding: 0 5px;
    }
  }

  &__submenu {
    position: absolute;
    display: none;
    top: 100%;
    left: -15px;
    width: 96%;
    margin: 0;
    flex-wrap: wrap;
    list-style: none;
    height: 80vh;
    background: #fff;
    overflow-y: auto;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    visibility: hidden;
    z-index: -9;
    transition: opacity 30s ease-in-out;
    max-height: 70vh;

    @media (max-width: 980px) {
      width: 100%;
    }

    &--sale,
    &--highlight {
      height: auto;
    }

    &--sale {
        &-box {
            width: 100%;
        }
        &-title {
            font-weight: 600;
            font-size: 14px;
            line-height: 19px;
            padding: 20px 30px 10px 30px;
        }
        &-more {
            padding: 10px 30px 5px 30px;
            text-align: center;

            .menu__submenu--sale-more-link {
                text-decoration: underline;

                &:hover {
                    text-decoration: none;
                }
            }
        }
    }

    &--simple {
      width: 200px;
      height: auto;
      display: flex;
      background: #fff;
      left: -17px;

      > ul {
        width: 100%;
        padding: 0;
        opacity: 1;
        background: #fff;
        height: auto;
      }

      a {
        &:hover {
          color: #e6007e;
          background: #fff;
        }
      }

      .menu-second__link {
        line-height: 25px;
        font-weight: 500;
      }
    }

    &__link {
      color: #333333;
      display: inline-block;
      padding: 0 0 1rem;
      font-size: 15px;

      &:hover {
        color: #e6007e;
      }
    }

    &__image {
      padding: 0.5rem 0 0;
      max-width: 100%;
      max-height: 100px;
    }
  }

  &__link {
    font-size: 14px;
    flex-grow: 1;
    line-height: 42px;
    color: #333;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    position: relative;
    text-decoration: none;
    font-weight: 500;

    &--arrow {
      padding-right: 25px;
    }

    &::before {
      position: absolute;
      left: 0;
      bottom: 0;
      content: '';
      width: 100%;
      height: 35px;
      box-shadow: 0 0 4px 3px rgba(0, 0, 0, 0.08);
      border-radius: 10px;
      transition: height 0.5s linear;
      display: none;
    }

    &.menu__link--wrapper {
      padding: 0 5px;

      &:after {
        bottom: -16px;
      }

      &:before {
        bottom: -6px;
      }
    }

    &--sale--hover {
      &:hover {
        background: #e6007e;
        color: #fff;
      }
    }

    &--blackFriday {
      color: white;
      background: black;
      border-radius: 25px;
      display: flex;
      align-items: center;
      padding: 0 10px 0 5px;
      height: 30px;

      img {
        margin-right: 4px;
        background: white;
      }
    }

    &--christmas {
      color: #e6007e;

      img {
        margin-right: 4px;
      }
    }

    &--articles {
      &:hover {
        color: #e6007e;
      }
    }

    &--sale,
    &--highlight {
      color: #e6007e;
      border: 1px solid #e6007e;
      border-radius: 15px;
      padding: 6px 32px 6px 16px;
      font-size: 14px;
      line-height: 18px;
      z-index: 104;

      .menu__submenu {
        margin-top: 6px;
      }

      .menu--arrow {
        border-top: 6px solid #e6007e;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
      }

      &::before {
        background-color: #fddde2;
        z-index: -1;
      }
    }
      &--highlight {
          position: relative;
          padding: 6px 16px 6px 35px ;

          &:before {
              background-size: cover;
              width: 20px;
              height: 20px;
              content: '';
              position: absolute;
              top: 5px;
              left: 11px;
          }
      }
      &--xmas:before {
          background: transparent url('../../icons/xmas.svg') no-repeat scroll 50% 50%;
      }
      &--sale:before {
          background: transparent url('../../icons/sale.svg') no-repeat scroll 50% 50%;
      }
  }

  &__item {
    flex-grow: 1;
    display: inline-block;
    min-height: 37px;

    &:empty { display: none; }

    &--right {
      float: right;
      text-transform: uppercase;

      .menu__submenu {
        right: 0;
        left: auto;
      }
    }

    &--simple {
      position: relative;

    }
  }

  &--opened {
    &::after {
      visibility: visible;
      opacity: 0.5;
    }

    .menu__item {
      &--active {
        .menu__bookmark {
          position: relative;

          &--sale,
          &--highlight {
            padding: 0 0 6px 0;

            .menu__link--wrapper {
              padding-top: 6px;
            }
          }
          &--highlight .menu__link--wrapper {
            padding: 6px 5px 0 5px;
          }

          &.menu__submenu {
            height: auto;
          }

          &:after, &:before {
            content: "";
            width: 15px;
            height: 15px;
            position: absolute;
            bottom: -1px;
            border-top: 0;
            background: #fff4f2;
            z-index: 101;
          }

          &:after {
            border-left: 0;
            border-radius: 0 0 5px 0;
            left: -15px;
            box-shadow: inset -8px -6px 6px -5px rgba(0, 0, 0, 0.08);
          }

          &:before {
            border-right: 0;
            border-radius: 0 0 0 5px;
            right: -15px;
            box-shadow: inset 8px -6px 6px -5px rgba(0, 0, 0, 0.08);
          }
        }

        .menu__link  {
          text-decoration: none;
          background: #fff;
          color: #e6007e;
          border-radius: 10px;

          &::after {
            position: absolute;
            bottom: -11px;
            width: calc(100% + 6px); //negative left position
            height: 19px;
            background: #fff;
            left: -6px;
            content: "";
            z-index: 100;
          }

          &::before {
            display: block;
            height: 42px;
          }

          .menu--arrow {
            top: 44%;
            border-top: 0;
            border-bottom: 6px solid #e6007e;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
          }
        }

        .menu__submenu--sale,
        .menu__submenu--highlight {
          height: auto;
        }

        .menu__submenu {
          scroll-behavior: smooth;
          visibility: visible;
          opacity: 1;
          display: flex;
          z-index: 102;
        }
      }
    }

  }

  &-sales {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 5px 30px 25px 30px;

    &--only-category {
        padding-top: 25px;
    }

    &--link {
      background: #FFFFFF;
      box-shadow: 0 4px 19px -8px rgba(0, 0, 0, 0.33);
      border-radius: 10px;
      margin: 10px 30px 10px 0;
      font-weight: 500;
      font-size: 14px;
      line-height: 19px;
      position: relative;
      width: 270px;
      padding: 14px 17px;

      img {
        margin-right: 15px;
      }

      .svg {
        fill: #fff;
        position: absolute;
        width: 25px;
        height: 25px;
        border-radius: 33px;
        transition: all 0.3s;
        z-index: 5;
        right: 10px;
        background-color: #c2a4d1;
        display: flex;
        align-items: center;
        justify-content: center;
        top: 14px;
        padding: 8px;
      }
    }

    .menu-second__item {
        width: 295px;
    }
  }

  .menu--scroll {
    fill: #fff;
    position: absolute;
    width: 25px;
    height: 25px;
    border-radius: 33px;
    transition: all 0.3s;
    z-index: 5;
    right: 10px;
    background-color: #c2a4d1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    left: 50%;
    bottom: 15px;
    transform: rotate(90deg);
  }

  &__brand-button {
    background: #e6007e;
    border-radius: 15px;
    padding: 0px 15px;
    line-height: 40px;
    color: #fff;
    display: inline-block;
    margin: 10px auto 20px;
  }
}
</style>
